import { Container, Form, Alert, Tab, Tabs} from 'react-bootstrap';
import {Sida,Rubrik,Stycke,Button,ContentWrapper} from "../ContentStyles";
import React, { useState ,useEffect} from 'react';
import useBackend, {CallAPI, Spinner, CallAPIGet} from '../../services/useBackend';
import QRCode from "react-qr-code";

export default function Login() {
	const [resultText, setResultText] = useState(":)");
	const [resultVariant, setResultVariant] = useState("success");
	const [resultVisible, setResultVisible] = useState(false);
	const [spinnerHidden, setSpinnerHidden] = useState(true);  

	const [bankIDorderRef, setBankIDorderRef] = useState('');  
	const [bankIdQRValue, setBankIdQRValue] = useState('');  
	const [activeTab, setActiveTab] = useState('..');

	useEffect(() => {
		const interval = setInterval(async () => {
				if (bankIDorderRef!='') await updateBankID();
		}, 1000);

		return () => { clearInterval(interval); };
	}, [bankIDorderRef]);		

	async function handleAuthPassword(e) {
		e.preventDefault();
		setSpinnerHidden(false);
		setResultVisible(false);
	
		const formData = new FormData(e.target),
		formDataObj = Object.fromEntries(formData.entries())
		
		let {resultVariant, errorsException, resultVisible, resultText, jsondata} = await CallAPI('/api/auth/password','POST',JSON.stringify(formDataObj));

        if (errorsException==false) {
            setResultVariant("success");      
            setResultText(jsondata.resultText);        
            setSpinnerHidden(true);
            setResultVisible(true);
            localStorage.setItem('access_token', jsondata.access_token);

			var RedirectTo = "/start";

			if (jsondata.redirectTo!="") RedirectTo = jsondata.redirectTo;

            setTimeout(function() { window.location.href = RedirectTo; }, 1400);
        } else {
            setResultVariant("warning");
            setResultText(resultText);
            setSpinnerHidden(true);
            setResultVisible(true);
        }		
	}

	async function updateBankID(){
		let {resultVariant, errorsException, resultVisible, resultText, jsondata} = await CallAPI('/api/auth/BankIDAuthState/'+bankIDorderRef,'GET');
		setResultVisible(true);	
		setResultText(resultText);
		if (jsondata.qr_diff>30) setBankIDorderRef('');
		if (jsondata.status == "complete") {
			setBankIDorderRef('');
            localStorage.setItem('access_token', jsondata.access_token);

			var RedirectTo = "/cities";
			if (jsondata.redirectTo!="") RedirectTo = jsondata.redirectTo;

            setTimeout(function() {
              window.location.href = RedirectTo;
            }, 1400);
		}
		setBankIdQRValue(jsondata.qr_token);
	}	

	async function initBankID(){
		setBankIDorderRef('');
		let formDataObj = {};
		let {resultVariant, errorsException, resultVisible, resultText, jsondata} = await CallAPI('/api/auth/BankIDAuthInit','POST',JSON.stringify(formDataObj));
		setResultVisible(true);	
		setResultText(resultText);
		setBankIDorderRef(jsondata.orderRef);
	}

	async function handleSelect(key) {
		if (key=='bankid') {
			await setActiveTab(key);
			initBankID();				
		} else {
			setResultVisible(false);				
			setResultText('');			
		}
	}

  	return (
		<ContentWrapper>
		<Container>
			<Sida>
			<Rubrik>Login</Rubrik>
			<Tabs defaultActiveKey="password" id="uncontrolled-tab-example" className="mb-3" onSelect={(i)=>handleSelect(i)}>

				<Tab eventKey="bankid" title="BankID"> 
					<Form>
						<Form.Group className="mb-3">
							<QRCode value={bankIdQRValue} viewBox={'0 0 512 512'} style={{ height: "auto", maxWidth: "100%", width: "256" }}></QRCode>
						</Form.Group>

						<Form.Group className="mb-3"  hidden={!resultVisible}>
							<Alert show={resultVisible} variant={resultVariant}  className="FormSpace_">{resultText}</Alert> 
						</Form.Group>  

						<Form.Group className="mb-3"  hidden={spinnerHidden}>
							<Spinner />
						</Form.Group>                               
					</Form>				
				</Tab>

				<Tab eventKey="password" title="Lösenord">
					<Form onSubmit={handleAuthPassword}>
						<Form.Group className="mb-3">
							<Form.Label className="FormHeaderText">Email</Form.Label>
							<Form.Control autoFocus type="text" name="username" />
						</Form.Group>

						<Form.Group className="mb-3">
							<Form.Label className="FormHeaderText">Password</Form.Label>
							<Form.Control type="password" name="password" />
						</Form.Group>

						<Form.Group className="mb-3"  hidden={!resultVisible}>
							<Alert show={resultVisible} variant={resultVariant}  className="FormSpace_">{resultText}</Alert> 
						</Form.Group>  

						<Form.Group className="mb-3"  hidden={spinnerHidden}>
							<Spinner />
						</Form.Group> 

						<Form.Group className="mb-3">
							<Button className="QmeButton" variant="primary" type="submit">Logga in</Button>
						</Form.Group>         

						<Form.Group className="mb-3">
						<a href="/password/request/new" className="text-decoration-none"  style={{color:'#000', fontSize:'16px'}}>Glömt lösenord</a>
						</Form.Group>                       
					</Form>
				</Tab>				
			</Tabs> 
			</Sida>
		</Container>
		</ContentWrapper>
  	);
}